export function IconProps() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.5 3.5h5.585a1.5 1.5 0 0 0 2.83 0h.585a.5.5 0 0 0 0-1h-.585a1.5 1.5 0 0 0-2.83 0H1.5a.5.5 0 0 0 0 1zm7 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM1.5 9.5h5.585a1.5 1.5 0 0 0 2.83 0h.585a.5.5 0 0 0 0-1h-.585a1.5 1.5 0 0 0-2.83 0H1.5a.5.5 0 0 0 0 1zm7 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM3.085 6.5H1.5a.5.5 0 0 1 0-1h1.585a1.5 1.5 0 0 1 2.83 0H10.5a.5.5 0 0 1 0 1H5.915a1.5 1.5 0 0 1-2.83 0zM5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
        </svg>

    );
}
